import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ebbb7da"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  r: "9",
  cx: "10",
  cy: "10",
  "stroke-width": "1.5",
  stroke: "hsl(0 0% 80% / 0.5)",
  fill: "none"
}, null, -1))
const _hoisted_3 = ["stroke-dasharray"]
const _hoisted_4 = {
  x: "10",
  y: "7",
  "font-size": "1.2",
  "text-anchor": "middle",
  "alignment-baseline": "central"
}
const _hoisted_5 = {
  x: "10",
  y: "10",
  "font-size": "2.5",
  "font-weight": "800",
  "text-anchor": "middle",
  "alignment-baseline": "central"
}
const _hoisted_6 = {
  "alignment-baseline": "central",
  "font-size": "1.8",
  "font-weight": "100"
}
const _hoisted_7 = {
  x: "10",
  y: "13",
  "font-size": "1.2",
  "text-anchor": "middle",
  "alignment-baseline": "central"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 20 20",
    width: _ctx.size,
    height: _ctx.size
  }, [
    _hoisted_2,
    _createElementVNode("circle", {
      r: "9",
      cx: "10",
      cy: "10",
      "stroke-width": "1.5",
      stroke: "#57c7c2",
      "stroke-linecap": "round",
      fill: "none",
      "stroke-dasharray": ((2 * 3.14 * 9) * (_ctx.count / _ctx.max)) + ' ' + _ctx.size,
      transform: "rotate(-90)",
      "transform-origin": "center"
    }, null, 8, _hoisted_3),
    _createElementVNode("text", _hoisted_4, _toDisplayString(_ctx.prefix), 1),
    _createElementVNode("text", _hoisted_5, [
      _createTextVNode(_toDisplayString(_ctx.value) + " ", 1),
      _createElementVNode("tspan", _hoisted_6, _toDisplayString(_ctx.unit), 1)
    ]),
    _createElementVNode("text", _hoisted_7, _toDisplayString(_ctx.suffix), 1)
  ], 8, _hoisted_1))
}